const instance = process.env.PUBLIC_INSTANCE || '';
const env = process.env.PUBLIC_ENV || '';
const gitRef = process.env.GIT_REF || '';

export const appVersion = (gitRef && gitRef !== 'main') ? gitRef : `${instance}-${env}-main`;
